import { render, staticRenderFns } from "./DateItem.vue?vue&type=template&id=f287a544&"
import script from "./DateItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./DateItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports